import { Injectable, inject } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Router,
  UrlTree,
  RouterStateSnapshot,
} from '@angular/router';
import { environment } from 'src/environments/environment';

const MAINTENANCE_PATH = '/authentication/maintenance';

/**
 * Redirects to the maintenance page when `environment.maintenanceMode` is set
 * (build-time flag). Runtime maintenance from the database is enforced by the
 * backend hook (HTTP 503) and MaintenanceInterceptor.
 *
 * Implements CanActivate and CanActivateChild so child route changes under
 * FullComponent are also checked.
 */
@Injectable({ providedIn: 'root' })
export class MaintenanceGuard implements CanActivate, CanActivateChild {
  private router = inject(Router);

  canActivate(
    _route: unknown,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    return this.check(state);
  }

  canActivateChild(
    _route: unknown,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    return this.check(state);
  }

  private check(state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const path = state.url.split('?')[0];

    if (!environment.maintenanceMode) {
      return Promise.resolve(true);
    }

    if (path === MAINTENANCE_PATH || path.startsWith(`${MAINTENANCE_PATH}/`)) {
      return Promise.resolve(true);
    }

    return Promise.resolve(this.router.createUrlTree([MAINTENANCE_PATH]));
  }
}
